export default {
  'AUTH': {
    'CONFIRM_PASSWORD': 'Confirm Password',
    'EMAIL': 'Email',
    'EMPTY_EMAIL': 'Email cannot be empty.',
    'EMPTY_PASSWORD': 'Password cannot be empty.',
    'FORGOT_PASSWORD': 'Forgot Password',
    'INVALID_EMAIL': 'Please provide a valid email.',
    'INVALID_PASSWORD': 'Password should have atleast {MINIMUM} characters.',
    'IDENTICAL_PASSWORD': 'Passwords must be identical.',
    'LINK_EXPIRED': 'Link expired.',
    'LINK_USED': 'Someone has already used this link. If its not you, please reset password again.',
    'LOGIN': 'Login',
    'NEW_PASSWORD': 'New Password',
    'PASSWORD': 'Password',
    'PASSWORD_UPDATED': 'Successfully updated the password.',
    'RESET_LINK_SENT': 'Reset link has been sent to registered email.',
    'RESET_PASSWORD': 'Reset Password',
    'SUBMIT': 'Submit',
    'USER_LOGIN': 'User Login',
    'USER_NOT_FOUND': 'No user found. Please contact admin.',
    'PWD_CHANGE': 'Change Password',
    'PWD_CURRENT': 'Current Password'
  },
  'ERROR': {
    'COMMON': 'Error occurred. Please try again.'
  },
  'HEADER': {
    'TRIAL_USER': 'You are a trial user. Trial Period ends on {END_DATE}.',
    'NOTIFY_MSG': 'You have {len} notifications',
    'CLEAR': 'Clear',
    'TEMPLATES': 'Templates',
    'FORMS': 'Forms',
    'UPLOAD_FORM': 'Upload Form',
    'REPORTS': 'Reports',
    'PROFILE': 'Profile',
    'USERS': 'Users',
    'LOGS': 'Logs',
    'SETTINGS': 'Settings',
    'LOGOUT': 'Logout',
    'ACCOUNTS': 'Accounts',
    'MODELS': 'Models',
    'Features': 'Features'
  },
  'TEMPLATE': {
    'DATE_CATEGORY': 'Date Category',
    'DATE_FORMAT': 'Date Format',
    'ADD_NEW': 'Add a New Template',
    'ENABLE_AUTO_CORRECT': 'Enable Auto Correct: ',
    'CLONE': 'Clone a template from other account.',
    'CREATE_NPI_GROUP': 'Create NPI Group',
    'DATA_TYPE': 'Data Type',
    'DELETE_CONTENT': "Do you want to delete this '{TEMPLATE_TITLE}' template?",
    'DELETE_MAP': 'Delete Mapping (Cmd + d)',
    'DELETE_MODAL': 'Delete Mappings',
    'DELETE_MODAL_CONTENT': 'Are you sure, Do you want to remove the Field?',
    'DRAW': 'Draw',
    'DISABLE_FORM': 'Disable For Form Submission',
    'ENABLE_FORM': 'Enable For Form Submission',
    'ENTER_TITLE': 'Enter title....',
    'ENTER_DESCR': 'Enter template description',
    'GRP_NAME': 'Group Name',
    'GRP_TYPE': 'Group Type',
    'KEY': 'Key',
    'MAPPING_CATEGORY': 'Category',
    'ORDER_OF_OCCUR': 'Order of Occurance',
    'CASE': 'Case',
    'MAPPINGS': 'Mappings:',
    'MSG_ADDED': 'Added template successfully.',
    'MSG_REMOVED': 'Removed template successfully.',
    'MSG_SAVED': 'Editor changes are successfully saved.',
    'MSG_SAVE_FAIL': 'Something went wrong. Saving failed...',
    'NEXT_PAGE': 'Go to next page',
    'NOTHING': 'No templates found!',
    'ESMMAPPINGS': 'External Service Mappings',
    'TEMPLATE_VERSION_UPDATE': 'Do you want to clone the Fields mappings for new template version?',
    'ESM_CLONING': 'External Service Mappings will be cloned',
    'ORTF_CLONING': 'ORTF Mappings will be cloned',
    'SV_CLONING': 'Service Validations will be cloned',
    'HL7_CLONING': 'HL7 Mappings will be cloned',
    'CV_CLONING': 'Custom Validations will be cloned',
    'NPI_GROUP': 'NPI Group',
    'OLDER_VERSIONS': 'Older versions cannot be edited',
    'PREV_PAGE': 'Go to previous page',
    'REDO': 'Redo (Cmd + Shift + z)',
    'REQ': 'Required',
    'EXT': 'Extraction',
    'EXT_BY_WORDS': 'Extract By Words',
    'REDACT_FIELD': 'Redact Field',
    'SHOW_FIELD': 'Show Field',
    'SENS_DATA': 'Sensitive Data',
    'REQ_TYPE': 'Select Process type',
    'REQ_FILE': "File can't be blank",
    'REQ_TITLE': "Title can't be blank",
    'SAVE': 'Save (Cmd + s)',
    'SAVE_CHANGES': 'Do you like to save changes before leaving editor?',
    'SELECT': 'Select (Esc)',
    'SELECT_DATA_TYPE': 'Please select data type',
    'SELECT_DATE_FORMAT': 'Please select date format',
    'SELECT_TYPE': 'Please select type',
    'SELECT_FROM_ACCOUNT': 'From Account',
    'SELECT_TO_ACCOUNT': 'To Account',
    'SELECT_ACCOUNT': 'Select Account',
    'SELECT_TEMPLATE': 'Select Template',
    'SELECT_CASE': 'Select Case',
    'TEMPLATE': 'Template',
    'THEME': 'Theme',
    'THUMBNAIL': 'Thumbnail',
    'TRAIN': 'Train',
    'TRAIN_BASE': 'Train Base Template:',
    'TYPE': 'Type',
    'UPDATE_MAP': 'Update Mapping',
    'UPDATE_GRP': 'Update Group',
    'UNDO': 'Undo (Cmd + z)',
    'UNSAVE': 'Unsaved Changes',
    'ZOOM_IN': 'Zoom In (Cmd+ +)',
    'ZOOM_OUT': 'Zoom Out (Cmd+ -)',
    'IMPORT': 'Import',
    'EXPORT': 'Export',
    'ALIAS': 'Alias',
    'UPLOAD_MAPPINGS': 'Upload Mappings File'
  },
  'TEMPLATE_VIEW': {
    'ID': 'ID',
    'PAGES': ' PAGE(S)',
    'TOTAL_PAGES': 'Total Page(s)',
    'UPDATED_AT': 'Updated at',
    'VIEW': 'VIEW:',
    'BRAND': 'Brand'
  },
  'DATA_TYPE': {
    'ALPHA': 'Alphabets',
    'ALPHANUM': 'Alphanumeric',
    'ALPHANUMSPC': 'Alphanumeric With Spaces',
    'NUMERICDEC': 'Numeric With Decimal',
    'BLOCK': 'Block',
    'CHECKBOX': 'Checkbox',
    'CITY': 'City',
    'COMBINE_DATA': 'Combine Data',
    'NAME': 'name',
    'CHECKBOX_TEXT': 'Checkbox Text',
    'DATE': 'Date',
    'DEFAULT': 'Default',
    'EITHER': 'Either-or Choice',
    'LOGICAL': 'Logical',
    'MULTI_CHOICE': 'Multiple Choice',
    'NPI': 'NPI',
    'NUMERIC': 'Numeric',
    'STATE': 'State',
    'TABLE_COLUMN': 'Table ( Column Data )',
    'TABLE_ENTRY': 'Table Entry',
    'TABLE_HEADER': 'Table Header',
    'TABLE_ROW': 'Table ( Row Data )',
    'TEXT': 'Text',
    'ZIPCODE': 'Zipcode',
    'CAPITALIZE': 'Capitalize the First Letter of Field',
    'UPPER_CASE': 'Upper Case',
    'LOWER_CASE': 'Lower Case',
    'SECTION': 'Section'
  },
  'COLOR': {
    'BLUE': 'Blue',
    'GREEN': 'Green',
    'RED': 'Red'
  },
  'UPLOAD_DROPDOWN': {
    'ENROLLMENT_FORMS': 'Enrollment forms',
    'SELECT': 'Select',
    'AUTO': 'Auto match',
    'PLAIN': 'Plain text',
    'INSURANCE': 'Insurance card',
    'INSU_F_B': 'Front and back insurance cards',
    'MANUAL': 'Manual',
    'DL': 'Drivers License/Voter ID',
    'INVOICE': 'Invoice',
    'EXCEL': 'Excel Workbook',
    'LEASE': 'Lease Document',
    'SLA': 'Software Licensing Agreement',
    'AUS_LEASE': 'Australian Lease Document',
    'MEDTRONIC': 'Medtronic',
    'MEDTRONIC2': 'Medtronic-2',
    'BIOTRONIK': 'Biotronik',
    'BOSTON': 'Boston Scientific',
    'TRIAGING': 'Triaging'
  },
  'FORMS': {
    'ROTATE_LEFT': 'Rotate Left',
    'ROTATE_RIGHT': 'Rotate Right',
    'IMAGE_ROTATE_SUCCESS': 'Image rotation successful',
    'IMAGE_ROTATE_FAIL': 'Image Rotation Failed',
    'MULTI_USER_MODAL': 'WARNING',
    'MULTI_USER_ALERT_MSG': 'Currently another user is viewing this Document. Kindly validate other document',
    'ACCEPT_PERMISSION_ERROR': 'Cannot accept form permission required!',
    'NEXT_FORM': '<< Next document',
    'PREV_FORM': 'Previous document >>',
    'SELECT_MODEL': 'Select Model',
    'MODEL_NAME': 'Model name',
    'MODEL_NAME_ERR': 'Model name can\'t be blank',
    'USE_TITLE': 'Use same title for all forms',
    'CONF_RANGE': 'Confidence Range',
    'CHECK_ELIG_BTN_LABEL': 'Check Eligibility',
    'CHECK_ELIG_SUCC_MESSAGE': 'Eligibility Check Successful',
    'CHECKING_ELIG_BTN_LABEL': 'Checking Eligibility',
    'AVG_CONF': 'Average Confidence',
    'COMP_IMAGES': 'Compare with uploaded images',
    'NO_LINE_ITEMS': 'No Line Items to Display...',
    'ACCEPT': 'Export',
    'VERIFY': 'Verify',
    'APPROVED': 'APPROVED',
    'ADD_FIELD': 'Add Field',
    'ALL': 'For all the Forms',
    'CON_SCORE': 'Confidence Score',
    'CHANGE_LABEL': 'Change Label',
    'CHOOSE': 'Choose a form...',
    'DELETE_CONTENT': 'Do you want to delete {FIELD_NAME} field?',
    'DESCRIPT_PLACE': 'Enter Form Description',
    'DROP_SCANNED': 'Click here / Drag and drop files here to process',
    'DROP_TEMP_SCANNED': 'Click here / drag and drop files to upload',
    'EDITED': 'Edited',
    'AUTO_CORRECT': 'Auto Correct',
    'AUTO_CORRECT_CONTENT': 'Updated value will be used futhur ,are you sure you want to save ?',
    'EXPORT_ERROR': 'Salesforce Export Mappings Error',
    'FORCED_TEMPLATE': 'Forced template',
    'LABEL': 'Label',
    'LABEL_NAME': 'Label Name',
    'MATCH': 'Match',
    'MATCHING_TEMPLATE': 'View Matching Template',
    'MSG_ACCEPT': 'Form accepted',
    'MSG_DEL': 'Data deleted successfully',
    'MSG_LABEL': 'Label changed successfully',
    'MSG_SUCESS': 'Data updated successfully',
    'MSG_WARN': 'Uploaded form is not processed',
    'NOTHING': 'No data to display...',
    'ONLY': 'Only for this Form',
    'PENDING': 'PENDING',
    'PAGES_WITH_DATA': 'Pages with data',
    'PROCESS_TYPE': 'Process Type',
    'PROCESSED_DATA': 'Processed Data',
    'PROCESSING_STAT': 'Uploaded forms are being processed... Please wait',
    'PROCESSED_STAT_ONE': 'New form has been processed. Click to refresh',
    'PROCESSED_STAT_MANY': 'New forms have been processed. Click to refresh',
    'REJECTED': 'REJECTED',
    'REQ_TITLE': "Title can't be blank",
    'REQ_LABEL': "Name can't be blank",
    'REQ_FILE': "File can't be blank",
    'SELECT_PAGE_NUM': 'Page: ',
    'TABLE_DATA': 'Table Data',
    'TEMPLATE': 'Template',
    'TITLE_PLACE': 'Form Title...',
    'UPLOAD_PROCESS': 'Upload and processing...',
    'UPLOADING': 'Uploading...',
    'UPLOAD_A_FORM': 'Upload A Scanned Form',
    'UPLOAD_MULTI_FORMS': 'Upload Scanned Forms',
    'VALUE': 'Value',
    'VALIDATION_HEADER': 'Please correct / fix the following fields',
    'VALIDATE_SIGNATURE': 'Please approve / reject signature to verify',
    'VALIDATIONS': 'Validation Errors',
    'REQUIRED_FIELDS_VALIDATION': 'Required Fields Errors',
    'SERVICE_VALIDATION': 'Service Validation Errors',
    'VALIDATION_ERROR': 'Validation Errors',
    'SERACH_PLACEHOLDER': 'Search for Process Value',
    'OPTIONAL_FIELDS_VALIDATION': 'Optional Fields Errors'
  },
  'WORKFLOW': {
    'ACTIONS': 'Actions',
    'ANALYSE': 'Analyse',
    'ANALYSIS': 'Analysis',
    'TITLE': 'File Name',
    'INVOICE': 'Invoice',
    'DOWNLOAD': 'Download',
    'FILTER': 'Filters',
    'FILTERS': 'Filters',
    'MATCH': 'Match',
    'GROUP_ID': 'Group ID',
    'PROCESSED_FORMS': 'Processed Forms',
    'PROCESS_PAGE_COUNT': 'Processed Page Count',
    'PAGE_COUNT': 'Page Count',
    'MATCHED_PAGE_COUNT': 'Matched Page Count',
    'REJECT_PAGE_COUNT': 'Rejected Page Count',
    'SEARCH': 'Type to Search',
    'UPDATED_AT': 'Updated at',
    'CREATED_AT': 'Created at',
    'DOC_RECIEVED_AT': 'Document Recieved at',
    'TIME_DIFF': 'Time Difference',
    'TURN_AROU_TIME': 'Turnaround Time',
    'DELETE_FORM': "Do you want to delete this '{FORM_TITLE}' form?",
    'FAX_NUMBER': 'Fax Number',
    'ENTER_FAX_NUMBER': 'Enter Fax Number',
    'DELETE': 'Delete Forms',
    'FORM_INFO_HEADER': 'Processed Forms Details',
    'DELETE_MULTIPLE': 'Delete Mutliple Forms',
    'REPROCESS': 'Reprocess',
    'MAX_RETRIES': 'Reached Max retries count.',
    'MOVE_TO_MATCHED': 'Move to matched queue',
    'SF_STATUS': 'Status',
    'LOCK_TITLE': 'Locked by {userName}',
    'LOCK_ALERT_MSG': 'Do you want to unlock this record ?',
    'DOCUMENT_TYPE': 'Document Type',
    'PRODUCT': 'Product',
    'REPORT': 'Report'
  },
  'ANALYTICS': {
    'TOTAL_FORMS': 'Total Received Forms',
    'CONFIDENCE': 'Confidence (%)',
    'CONFIDENCE_AVG': 'Template Page Confidence Average (%)',
    'DAILY_REPORT': 'Daily Report',
    'FILTER_TEMPLATES': 'Filter by Templates',
    'FORM_WORKFLOW_STATS': 'Form Workflow Statistics',
    'IDENTIFIED': 'Identified',
    'RECENT_FORMS': 'Recent Forms',
    'FORMS_INSIGHTS': 'Forms Insights',
    'FAXES_RECEIVED': 'Total Number Of Patient Forms Received',
    'FAXES_IDENTIFIED': 'Total Number Of Patient Forms Identified',
    'FAXES_READABLE': 'Total Number Of Patient Forms Readable',
    'FAXES_REJECTED_ORIGIN': 'Total Patient Forms Rejected Based On Country',
    'FAXES_REJECTED_BY_REASON': 'Total Patient Forms Rejected Due To Readability',
    'FAXES_UNPROCESSED': 'Total Patient Forms Not Matched To Template',
    'REJECTED': 'Rejected Reason',
    'WEEKLY_REPORT': 'Weekly Report',
    'TOTAL_PROCESSED': 'Processed',
    'TOTAL_REJECTED': 'Rejected',
    'TEMPLATE': 'Template',
    'PROCESS_TYPE': 'Process Type',
    'SELECT_PROCESS_TYPE': 'Process Type',
    'PAGES': 'Page(s)',
    'RECENT_FORM_MSG': 'Recent forms generated in the CSV will belong to selected date range only.',
    'REPORT_CONTENT': 'Report Content',
    'TOTAL_FIELDS': 'Total Field(s)',
    'TRANSCRIBED_FIELDS': 'Transcribed Field(s)',
    'ACCURACY_PERCENTAGE': 'Accuracy Percentage (%)',
    'EDITED_FIELDS': 'Edited Field(s)'
  },
  'CONFIGURED': {
    'ADD_ROLE': 'Add Role',
    'ADD_GROUP': 'Add Field',
    'ADD_ALIAS': 'Add Alias',
    'ADD_FIELD_ALIAS': 'Add Field aliases',
    'ADD_NEW_KEYS': 'Add New Keys',
    'B_PREVIEW': 'Border Preview',
    'CONFIDENCE_COLORS': 'Confidence Colors',
    'CC_SUCCESS': 'Confidence colors are updated successfully',
    'COLOR': 'Color',
    'CREATE': 'Create',
    'IMPORT_MAPPINGS': 'Import Mappings',
    'EDIT_GROUP': 'Edit Field',
    'EDIT_ALIAS': 'Edit Alias',
    'FORM_ORDER': 'Form Processing Order',
    'FIELD_TYPE': 'Field Type',
    'FIELD_EXISTS': 'Already field exists',
    'FIELDS': 'Fields',
    'FIELDS_ALIASES': 'Field aliases',
    'NEW_ROLE': 'New Role',
    'NOTE': 'Note: Drag/drop the items to change the form processing order',
    'PREVIEW': 'Preview',
    'PROCESS_ORDER_SUCCESS': 'Processing order updated successfully',
    'RANGE': 'Range',
    'ROLE_CREATED': ' role is created successfully',
    'ROLE_MANAGE': 'Role Management',
    'ROLE_NAME': 'Role Name',
    'ROLE_NOTE': 'Note: Drag/drop the items to change the role order',
    'ROLE_ORDER': 'Role Order',
    'ROLE_ORDER_SUCCESS': 'Role Order is updated successfully',
    'ROLE_SUCCESS': 'Roles are updated successfully',
    'SELECT_ROLE': 'Select Role',
    'PROCESS_TYPE': 'Subscribed Process Types',
    'FIELD': 'Field Name',
    'SUBSCRIBE_MODAL': 'Subscribe a New Process Type',
    'UNSUBSCRIBE_MODAL': 'Unsubscribe a Process Type',
    'SUBSCRIBE_PT': 'Successfully subscribed a new process type',
    'UNSUBSCRIBE_PT': 'Successfully unsubscribed',
    'ENTER_SECTION_NAME': 'Enter Section Name',
    'SECTION_ORDER': 'Section Order',
    'SECTION_NOTE': 'Note: Drag/drop the items to change the Section Order',
    'SECTION_ORDER_SUCCESS': 'Section Order is updated successfully',
    'HL7_TEMPLATES': 'HL7 Templates',
    'DOC_RETENTION': 'Rejection Time Period',
    'REQ': 'Required',
    'QUERY': 'Query',
    'FIELD_ALIAS': 'Field Alias'
  },
  'TRAILS': {
    'AUDIT_TRAILS': 'Audit Trails',
    'LOGGED_AT': 'Logged At',
    'LOCATION': 'Location',
    'PATH': 'Path',
    'CUSTOM_DATE_LOGS': 'Custom Date Logs'
  },
  'USERS': {
    'ACCOUNT': 'Account',
    'ADD_NEW': 'Add New User',
    'EMAIL': 'Email',
    'PASSWORD': 'Password',
    'PASS_CONFIRM': 'Password Confirmation',
    'REPEAT': 'Repeat Password',
    'LINK': 'Link',
    'LIST': 'Users List',
    'LOGOUT': 'Logout',
    'REQ_USERNAME': "Username can't be blank",
    'REQ_MIN_LENGTH': 'Username must be of minimum 5 characters length',
    'REQ_ONLY_ALPHANUM': 'Username can be only alphanumeric characters',
    'REQ_EMAIL': "Email can't be blank",
    'REQ_VALID_EMAIL': 'Please provide a valid email address',
    'REQ_PASS': "Password can't be blank",
    'REQ_PASS_MIN_LENGHT': 'Password must be of minimum 8 characters length',
    'REQ_NO_MATCH': 'Password and Repeated Password are not matching',
    'REQ_ACCOUNT': "Account can't be blank",
    'CREATE_ROLE': 'Atleast 1 role must be created in settings to create users.',
    'REQ_ROLE': "Role can't be blank",
    'ROLE': 'Role',
    'ROLES': 'Roles',
    'SELECT_ROLE': 'Please select a role',
    'SELECT_TEAM': 'Please select a team',
    'TEAM': 'Team',
    'T_END_DATE': 'Trial End Date',
    'USERNAME': 'Username',
    'LAST_LOGIN': 'Last Login'
  },
  'ACCOUNT': {
    'ADD_NEW': 'Add New Account',
    'CURRENT_SALESFORCE_ORG': 'Current Salesforce Organization:',
    'CURRENT_SALESFORCE_URL': 'URL:',
    'NAME': 'Account Name',
    'LIST': 'Accounts List',
    'VALID_BLANK': "Account name can't be blank.",
    'VALID_EXIST': 'Account name is already exist.',
    'VALID_MIN': 'Account name must be of minimum 5 characters length.',
    'ACCOUNT_TYPE': 'Account Type',
    'OCR_ENGINE': 'Ocr Engine',
    'PROCESS_TYPE': 'Process Type',
    'END_DATE': 'End Date',
    'VALID_OCR_ENGINE': 'Select an Ocr Engine.',
    'VALID_ACCOUNT_TYPE': 'Select an account type.',
    'VALID_END_DATE': 'Provide a valid end date.',
    'VALID_EMAIL': 'Provide a valid email(s).',
    'VALID_PROCESS_TYPE': 'Select atleast 1 process type.',
    'EDIT_ACCOUNT': 'Edit Account',
    'EMAIL': 'Email',
    'REASON': 'Reason',
    'ERRORS': 'ERRORS',
    'EMAIL_FORMAT': 'Invalid email format.',
    'EMAIL_DIFF_ACC': 'Email used with a different account.',
    'UPLOAD_LOGO': 'Upload Logo',
    'ACCOUNT_LOGO': 'Account Logo',
    'DELETE_CONTENT': 'Do you want to delete?'
  },
  'USER_DROPDOWN': {
    'PROFILE': 'Profile',
    'ADMINS': 'Admins',
    'LOGS': 'Logs',
    'SETTINGS': 'Settings',
    'LOGOUT': 'Logout'
  },
  'FAB_TITLES': {
    'ADD_NEW_USER': 'Add a New User',
    'ADD_TEMPLATE': 'Add Template',
    'EXPORT': 'Export',
    'NEW_ACCOUNT': 'New Account',
    'UPLOAD_FORM': 'Upload Form'
  },
  'ROUTE_NAME': {
    'Accounts': 'Accounts',
    'Admin': 'Admin',
    'Users': 'Users',
    'Add a New User': 'Add a New User',
    'Add New Account': 'Add New Account',
    'Configure': 'Configure',
    'Dashboard': 'Dashboard',
    'Edit Account': 'Edit Account',
    'Edit User': 'Edit User',
    'Form Status': 'Form Status',
    'Log History': 'Log History',
    'New Template': 'New Template',
    'Reports': 'Reports',
    'Reports Insights': 'Reports Insights',
    'Register': 'Register',
    'Template Listing': 'Template Listing',
    'Train': 'Train',
    'Sign In': 'Sign In',
    'Upload Form': 'Upload Form',
    'Form Doc': 'Verification',
    'Verification': 'Verification',
    'Triaging': 'Triaging',
    'Forms': 'Forms',
    'Audit Log Report': 'Audit Log Report',
    'My Profile': 'My Profile',
    'MODELS': 'Models',
    'page-not-found': '',
    'Features': 'Features'
  },
  'PROFILE': {
    'ROLES': {
      'UNMATCHED': 'Unmatched',
      'SUPERADMIN': 'Super Admin',
      'ADMIN': 'Admin',
      'TYPE_SELECT': 'Select Account type',
      'TRIAL': 'Trial Account',
      'SUBS_ACC': 'Subscribed Account'
    },
    'ACCNAME': {
      'DEFAULT': 'default'
    },
    'ACCOUNT_INFO': 'Account Information',
    'ACCOUNT_SET': 'Account Settings',
    'EMAIL_NOTIFY': 'Notify User via email',
    'ENTER_USER': 'Enter username',
    'ENTER_PASS': 'Enter new password',
    'INFO': 'Profile Information',
    'MEMBERS': 'Members',
    'UPDATE_SUCCESS': 'Profile updated successfully',
    'WRONG_PASSWORD': 'The credentials you supplied were not correct'
  },
  'COMMON': {
    'GO_BACK': 'GoBack',
    'OKAY': 'Ok',
    'FILE_ERROR': 'Error while parsing the file',
    'PROCESS_ORDER_INFO': 'Docx uses two techniques to find a matching template for an uploaded form. They are Barcode and Image Match. Barcode technique is where system looks for the templates which have similar barcode type as of form and Image Match is where it looks for similar features between template and form images. Depending on the processing order, system prioritizes the techinique which to be used. For example, If Barcode\'s processing order is 1, Barcode technique is preferred first and then Image Match.',
    'MODEL_EXIST': 'Model name already exists',
    'ADD_MODEL': 'Add new model',
    'NEW_MODEL': 'New model',
    'VERSION': 'Version',
    'CHOOSE_FILE': 'Choose File',
    'ACCEPT': 'Accept',
    'ACCEPTED': 'Accepted',
    'ACCOUNT': 'Account',
    'ACCOUNT_TYPE': 'Account type',
    'ACTION': 'Action',
    'ACTIONS': 'Actions',
    'ACTIVATE': 'Click to Activate',
    'ADD': 'Add',
    'ALERT': 'ALERT',
    'APPROVE': 'Approve',
    'APPLY': 'Apply',
    'CANCEL': 'Cancel',
    'CHANGE': 'Change',
    'CLEAR': 'Clear',
    'CLOSE': 'Close',
    'CLONE': 'Clone',
    'CONFIRM': 'Confirmation',
    'DATE_RANGE': 'Date Range',
    'DATE_START': 'Start Date',
    'DATE_END': 'End Date',
    'DAY': 'Day',
    'DEACTIVATE': 'Click to Deactivate',
    'DELETE': 'Delete',
    'DELETE_CONFIRM': 'Delete Confirmation',
    'DELETE_PERMANENTLY': 'Delete Permanently',
    'QBS': 'Export to QuickBooks',
    'SLSFRC': 'Export to Salesforce',
    'REMS': 'Export to Rems',
    'CSV': 'Download as CSV',
    'HL7': 'Download as 837',
    'FTP': 'Download as FTP',
    'OTRF': 'Download as ORTF',
    'EHR': 'Export to EHR',
    'FHIR': 'View FHIR data',
    'EDT_USR': 'Edit User',
    'MSG_PERM': 'User will be permanently removed from the system.',
    'MSG_PERM_DEL': 'You cannot undo this action. Are you sure you want to delete?',
    'MSG_DEL': 'This action will delete account\'s users, roles, templates, forms, service maps, settings etc...',
    'DEL_AUTHCONFIG': 'You cannot use this Client Id and Client Secret after deletion. Are you sure you want to delete?',
    'DEL_AUTO_CORRECT': 'This action will delete auto correct features and History for this field. Are you sure you want to delete?',
    'DEL_AUTO_CORRECT_HISTORY': 'This action will delete all the auto correct fields from the dictonary. Are you sure you want to delete?',
    'DEL_ORTFMAPPING': 'This action will permanently delete all ORTF field mappings of this template. Are you sure you want to delete?',
    'DEL_HL7MAPPING': 'This action will permanently delete HL7 field mappings of this template. Are you sure you want to delete?',
    'DEL_SERVICEMAPPING': 'This action will permanently delete all external field mappings of this template. Are you sure you want to delete?',
    'DEL_SERVICEVALIDATION': 'This action will permanently delete all service validations of this template. Are you sure you want to delete?',
    'DEL_CUSTOMVALIDATION': 'This action will permanently delete all Custom Validations of this template. Are you sure you want to delete?',
    'DESCRIPTION': 'Description',
    'ESM': 'Template Fields are not mapped with Salesforce object. Kindly check the settings',
    'TM': 'Template fields are not created. Kindly create fields in template',
    'DONE': 'Done',
    'EDIT': 'Edit',
    'EXPIRES_AT': 'Expires at',
    'EXPORT': 'Export',
    'FILE': 'File',
    'FORM': 'Form',
    'GENERATE': 'Generate',
    'GROUP_NAME': 'Group Name',
    'FILTER_BY': 'Filter By',
    'INTEGRATION_EMAILS': 'Integration Emails',
    'INVALID_FILE': 'Invalid File. (File must be format of .jpg, .jpeg, .png, .pdf, .tiff)',
    'LIST': 'List',
    'MARK_VERIFIED': 'Mark Verified',
    'MSG_CSV_LOG_DAYS': 'Maximum allowed Range is one month',
    'MSG_CSV_LOG_DAYS_ERROR': 'Please select range less than 31 days ',
    'MSG_ERROR_DATE': 'Invalid Date',
    'MSG_EXPIRED': 'Session expired, please login to continue',
    'MSG_RETRY': 'Something went wrong. Please retry',
    'MSG_REPROS': 'Requested form is being reprocessed.Please wait.',
    'MSG_DRAW': 'Please enable draw before creating shapes...',
    'MSG_INACTIVE': 'Currently requested service is not active. Sorry for the inconvenience.',
    'MSG_CREATE': 'Successfully created.',
    'MSG_UPDATE': 'Successfully updated.',
    'MSG_DELETE': 'Successfully deleted.',
    'MSG_DELETE_HISTORY': 'Successfully deleted from the dictionary',
    'MSG_DELETE_ERR': 'Error deleting. Please try again.',
    'MSG_FIELD_DEL': 'Field map is deleted',
    'MSG_LOGIN': 'Please login to access the requested page',
    'MSG_LOGIN_SUCESS': 'Logged in successfully. Welcome ',
    'MSG_USER_NF': 'User not Found!',
    'MSG_SERVER_UA': 'Server Unavailable!',
    'MSG_LOGIN_FAIL': 'Something went wrong. Login is failed',
    'MSG_LOGOUT': 'Logged out successfully',
    'MSG_USER_UPDATE': 'User updated successfully.',
    'MSG_SIGNUP_FAIL': 'Something went wrong. Sign Up is failed',
    'MSG_DATA_UPDATE': 'Data updated successfully',
    'MSG_USER_CREATE': 'User created successfully.',
    'MSG_ERROR': 'Error Occured. Try again.',
    'MSG_FORM_REQ': 'Either you do not have access to view form / Requested form not found.',
    'MSG_FETCH_ERR': 'Something went wrong while fetching form data.',
    'MSG_PROCESS_FAIL': 'Processing Failed, please try again.',
    'MSG_FILE_LIMIT': 'Maximum limit of files is 5.',
    'MSG_TEMP_FILE_LIMIT': 'Maximum limit of files is 1.',
    'MSG_TEMP_NAME_LIMIT': 'Title is too short (minimum is 3 characters). you cannot upload file',
    'MSG_TEMP_NAME_SUCCESS': 'Template Uploaded Successfully',
    'MSG_ACC_CREATE': 'Account created successfully.',
    'MSG_SUCESS_ACC': 'Account created successfully. Please sign in',
    'MSG_EDIT_N_A': 'Not Allowed to edit Admin',
    'MSG_ACC_SUCESS': 'Account updated successfully.',
    'MSG_UPD_FAIL': 'Something went wrong. Update failed.',
    'MSG_REQ_FIELD': 'This is a required field',
    'MSG_KEY_UNIQUE': 'Key must be unique.',
    'MSG_SELECT_TYPE': 'Please select type',
    'MSG_SELECT_CHILD': 'Select the children to delete along with the group:',
    'NAME': 'Name',
    'NEW': 'New',
    'NO': 'No',
    'ADD_NPI_GROUPING': 'Add NPI Grouping',
    'NOTIFICATION_EMAILS': 'Notification Emails',
    'ENTER_MULTIPLE_EMAILS': 'Enter a comma-separated email(s)',
    'NOTIFY_MSG': 'You have {len} notifications',
    'NO_RECORD': 'There are no records to show',
    'OF': 'of',
    'PENDING': 'Pending',
    'IN_PROGRESS': 'In Progress',
    'VALIDATED': 'Validated',
    'RECALLED': 'Recalled',
    'INTEGRATION_SUCCESS': 'Integration Success',
    'INTEGRATION_FAILED': 'Integration Failed',
    'DOCUMENT_MOVED_TO_SF': 'Document Moved To SF',
    'PC_INTEG_SUCCESS': 'Pc Integration Success',
    'PC_INTEG_FAILED': 'Pc Integration Failed',
    'TRIAGED': 'Triaged',
    'COMPLETED': 'Completed',
    'NEW_DOC': 'New',
    'PARTIALLY_COMPLETED': 'Partially Completed',
    'PROCESS': 'Process',
    'PROCESSED': 'Processed',
    'PRESCRIBER_FIRST_NAME': 'Prescriber First Name',
    'PRESCRIBER_LAST_NAME': 'Prescriber Last Name',
    'PRESCRIBER_NAME': 'Prescriber Name',
    'REJECT': 'Reject',
    'REJECTED': 'Rejected',
    'REQ_FIELD_WARNING': ' mandatory fields yet to be mapped',
    'RESET': 'Reset',
    'RESIZE': 'Resize',
    'SELECT': 'Select',
    'SAVE': 'Save',
    'SAVE_ALERT': 'There are some unsaved changes, please save them before leaving.',
    'SHOW_TABLE': 'Show Table',
    'STATUS': 'Status',
    'SUBMIT': 'Submit',
    'TITLE': 'Template Name',
    'USERNAME': 'Username',
    'UPDATE': 'Update',
    'UPLOAD': 'Upload',
    'UNBLOCK': 'Unblock',
    'UNMATCHED': 'Unmatched',
    'USERS': 'Users',
    'VALIDATE_UPDATE': 'Validate & Update',
    'VERIFY': 'Verify',
    'VERIFY_DOCUMENT': 'Verify Document',
    'VERIFIED': 'Verified',
    'VIEW_FORMS': 'View Forms',
    'YES': 'Yes',
    'SUBSCRIBE': 'Subscribe',
    'UNSUBSCRIBE': 'Unsubscribe',
    'UNAUTHORIZED': 'Unauthorized!',
    'UNMATCH': 'Form is not matched with any template',
    'WEEK': 'Week',
    'ENTER_PASSWORD': 'Enter Password',
    'WRONG_PASSWORD': 'Wrong Password',
    'Last Edited By': 'Last Edited By',
    'Enabled': 'Enabled'
  },
  'PROCESS_ROLES': {
    'BARCODE': 'Barcode',
    'IMAGE_MATCH': 'Image Match',
    'FORCE_TEMPLATE': 'Force Template',
    'PLAIN_TEXT': 'Plain Text'
  },
  'INVOICE': {
    'SIGN_INVOICE': 'SIGN INVOICE',
    'SIGN': 'Sign',
    'ACCOUNT': 'Account',
    'ACCOUNTING_UNIT': 'Accounting Unit',
    'TOTAL_AMOUNT': 'Total Amount',
    'ACC_REQ': 'Select an account',
    'ACC_UNIT_REQ': 'Select an accounting unit',
    'AMT_REQ': 'Total Amount is required',
    'MIN_AMT': 'Total Amount must be greater than or equal to zero',
    'SIGN_SUCCESSFUL': 'Successfully signed the invoice',
    'APPROVAL_SUCCESSFUL': 'Successfully approved the signature',
    'APPROVE_SIGN': 'APPROVE VERIFICATION',
    'APPROVE': 'Approve',
    'NOTES': 'Notes'
  },
  'TEAMS': {
    'TEAM': 'Team',
    'TEAMS': 'Teams',
    'ADD_NEW_TEAM': 'Add new team',
    'CREATE_TEAM': 'Create Team',
    'CREATE': 'Create',
    'NAME': 'Name',
    'DESCRIPTION': 'Description',
    'REQUIRED_FIELD': 'Required Field',
    'NO_USER_FOUND': 'No {ROLE}s found. Please add a new {ROLE}.',
    'NO_USER_ADDED': 'No {ROLE}s added to the team. Please add a {ROLE}.',
    'INCOMPLETE': 'Team is Incomplete. Some of the roles are missing in the hierarchy.',
    'DELETE_CONFIRM': 'Are you sure you want to delete this team permanently ?'
  },
  'Accounts': 'Accounts',
  'Add New': 'Add New',
  'Add User': 'Add User',
  'Admin': 'Admin',
  'Admins': 'Admins',
  'Aduit': 'Audit',
  'Analytics': 'Analytics',
  'Configure': 'Configure',
  'Forms': 'Forms',
  'Home': 'Home',
  'List': 'List',
  'Logs': 'Logs',
  'New': 'New',
  'New User': 'New User',
  'Processed': 'Processed',
  'Reports': 'Reports',
  'Settings': 'Settings',
  'Models': 'Models',
  'Super Admin': 'Super Admin',
  'Templates': 'Templates',
  'Trails': 'Trails',
  'Upload Form': 'Upload Form',
  'Users': 'Users',
  'Verification': 'Verification',
  'Workflow': 'Workflow',
  'Mappings': 'Mappings',
  'Add new mapping': 'Add new mapping'
}



// WEBPACK FOOTER //
// ./src/lang/en.js